import axios from '../js/axios.config'

export function refreshtoken(refresh_token) {
  
  return axios({
    url: '/refreshToken?refreshToken='+refresh_token, // 假地址 自行替换
    method: 'get'
  }).then(res => {
    return res.data;
  })
}
